import { ReactNode, useState } from 'react'

import AnnouncementBanner from '../Announcements/AnnouncementBanner'
import PreviewHeader from './PreviewHeader'
import PreviewSidebar, { readCollapsed } from './PreviewSidebar'
import './PreviewShell.css'

/**
 * The page frame for previewing the redesign: the new left navigation and the
 * new top bar, with the usual announcements. Only the preview routes use it -
 * every other page keeps components/Layout, the live sidebar and top bar.
 */
const PreviewLayout = ({
  children,
  userName,
  allowedRoutes,
}: {
  children: ReactNode
  userName: string
  allowedRoutes: string[]
}) => {
  const [collapsed, setCollapsed] = useState(readCollapsed)

  return (
    <div className={`pshell${collapsed ? ' pshell--collapsed' : ''}`}>
      <PreviewSidebar allowedRoutes={allowedRoutes} collapsed={collapsed} onCollapsedChange={setCollapsed} />
      <div className='pshell__main'>
        <PreviewHeader userName={userName} />
        <AnnouncementBanner />
        <main className='pshell__content'>{children}</main>
      </div>
    </div>
  )
}

export default PreviewLayout
